// Set the page label for Speedcurve RUM

export function setRUMPageLabel(pageLabel: string) {
  if (global.window && window.LUX) {
    window.LUX.label = pageLabel;
  }
}
